import { ReactNode } from 'react';
import WarningAlertIcon from '@mui/icons-material/ReportProblemRounded';
import InfoAlertIcon from '@mui/icons-material/TipsAndUpdates';
import ErrorIcon from '@mui/icons-material/Error';
import { SvgIcon } from '@mui/material';
import { twMerge } from 'tailwind-merge';

type AlertProps = {
  variant: AlertVariants;
  children: ReactNode;
  className?: string;
};

type AlertVariants = 'warning' | 'info' | 'error';

type AlertVariantProps = {
  icon: typeof SvgIcon;
  styles: string;
};

const alertVariants: Record<AlertVariants, AlertVariantProps> = Object.freeze({
  warning: {
    icon: WarningAlertIcon,
    styles: 'bg-yellow-100 text-yellow-600',
  },
  info: {
    icon: InfoAlertIcon,
    styles: 'bg-gray-100 text-gray-500',
  },
  error: {
    icon: ErrorIcon,
    styles: 'bg-red-100 text-red-500',
  },
});

export const Alert = (props: AlertProps) => {
  const baseStyles = 'flex items-center gap-main p-4 rounded-md mb-md';
  const { icon: Icon, styles } = alertVariants[props.variant];

  return (
    <div className={twMerge(baseStyles, styles, props.className)}>
      <Icon className="text-[3rem]" />
      {/*
        `min-w-0` porque este é um item flex, e item flex não encolhe abaixo do próprio conteúdo:
        um `<code>` longo no texto do alerta esticava a página inteira de lado no celular.
      */}
      <div className="min-w-0">{props.children}</div>
    </div>
  );
};
